import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './ArtistName.st.css';
var ArtistName = function (props) { return (React.createElement("span", { className: classes.title + " " + props.className, "data-hook": props.dataHook }, props.context.artistName)); };
ArtistName.displayName = 'ArtistName';
ArtistName.defaultProps = {
    className: '',
    dataHook: '',
};
export default withPlaybackContext(ArtistName);
//# sourceMappingURL=ArtistName.js.map